// ***  function for the validation of the user email   ***///

import moment from "moment";

//@@param value
export const permissions = {
  all: "All",
  kitManagement: "Kit Management",
  products: "Manage Products",
  users: "Manage Company Users",
  business: "Manage Business Profile",
  distributors: "Manage Distributors",
  resource: "Manage Resource Center",
  notifications: "Receive Update Notifications",
  dist_super_admin: "All Distributor",
  clients: "Manage Clients",
};

export const roles = {
  rm_super_admin: "rm_superadmin",
  rm_admin: "rm_admin",
  admin: "admin",
  approver: "approver",
  user: "user",
  superadmin: "superadmin",
  sales_representative: "salesrepresentative",
  distributor_super_admin: "distributor_superadmin",
  distributor_user: "distributor_user",
  distributor_salesrepresentative: "distributor_salesrepresentative",
};

export function validateEmail(value) {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  if (!emailRegex.test(value)) {
    return true;
  } else {
    return false;
  }
}

// ***  function for the validation onChange user only type number   ***///
//@@param value
export function onChangeToNumber(value) {
  return value.replace(/\D/g, "");
}

export const formatDateWithMonth = (date) => {
  const inputDateString = date;
  const dateObject = new Date(inputDateString);

  const options = { day: "numeric", month: "short", year: "numeric" };
  const formattedDate = dateObject.toLocaleDateString("en-GB", options);
  return formattedDate;
};

export const dateFormatter = (date) => {
  return moment(date).format("YYYY-MM-DD");
};
